module.exports = __webpack_public_path__ + "static/lhs-video-6e6223674ebee128e130eb9ae0d52629.webm";